import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface FunnelChartProps {
  data: Array<{ name: string; value: number }>;
  height?: number | string;
  loading?: boolean;
}

export function FunnelChart({ data, height, loading }: FunnelChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'item' },
    legend: { bottom: 0 },
    series: [{ type: 'funnel', left: '10%', right: '10%', top: 20, bottom: 40, minSize: '0%', maxSize: '100%', sort: 'descending', data, label: { show: true, formatter: '{b}: {d}%' } }],
  };
  return <EChart option={option} height={height} loading={loading} />;
}
